<script>
	const Vue = require('vue');
	const optimizedResize = require('utilities/optimizedResize');

	module.exports = {
		components: {
			'tab-container': require('components/tab-container.vue').default
		},
		props: {
			tabs: {
				required: true
			},
			tabKey: {
				required: true
			},
			onTabClick: {
				type: Function,
				default() {}
			},
			enableSnapToTop: {
				default: true
			}
		},
		data() {
			return {
				activeTab: null,
				scrollPositions: {},
				currentScrollTop: 0
			};
		},
		mounted() {
			let tabKey = this.tabKey;
			optimizedResize.add(this.onResize);
			this.$watchModel(tabKey, this.onTabChange);
		},
		beforeDestroy() {
			optimizedResize.remove(this.onResize);
		},
		computed: {
			snapToTopVisible() {
				let enableSnapToTop = this.enableSnapToTop;
				let currentScrollTop = this.currentScrollTop;
				let snapToTopVisible = false;

				if (enableSnapToTop && currentScrollTop > 0) {
					snapToTopVisible = true;
				}
				return snapToTopVisible;
			}
		},
		methods: {
			onTabChange(tab) {
				this.activeTab = tab;
				Vue.nextTick(() => {
					this.resetScrollPosition();
				});
			},
			onBodyScroll(event, forceUpdate) {
				let scrollPositions = this.scrollPositions;
				let activeTab = this.activeTab;

				this.currentScrollTop = 0;

				if (event && event.target) {
					let scrollTop = event.target.scrollTop;
					if (activeTab || forceUpdate) {
						scrollPositions[activeTab] = scrollTop;
						this.currentScrollTop = scrollTop;
					}
				}
			},
			resetScrollPosition() {
				let scrollPositions = this.scrollPositions;
				let activeTab = this.activeTab;
				let tabPanelBody = this.$refs.tabPanelBody;
				let position = scrollPositions[activeTab] || 0;

				if (activeTab && tabPanelBody) {
					tabPanelBody.scrollTop = position;
				}
			},
			scrollToTop() {
				let activeTab = this.activeTab;
				let scrollPositions = this.scrollPositions;

				scrollPositions[activeTab] = 0;
				this.resetScrollPosition();
			},
			onResize() {
				this.onBodyScroll(
					{
						target: this.$el
					},
					true
				);
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/variables';
	@import 'config/colors';
	@import 'mixins/flexbox';

	.tab-panel {
		margin: $size-small 0rem;
		@include flexbox();
		@include flex-direction(column);
		border: 1px solid $c-grey;

		.tab-panel-tabs {
			background-color: $c-blue-lighter;
			border: 1px solid $c-grey;
			border-width: 0 0 1px;

			.tab-panel-tab {
				color: $c-slate-dark;
				margin: 0;
			}
		}

		.tab-filler {
			display: none;
		}

		&.block-tabs {
			.tab-panel-tabs {
				background-color: none;
				border: none;

				.tab-list {
					flex: 1;
					display: flex;
					height: 100%;
				}

				.tab-panel-tab {
					position: relative;
					cursor: pointer;
					display: inline-block;
					padding: $size-medium $size-smedium;
					border: 1px solid $c-grey;
					border-width: 0 1px 1px 0;

					&.tab-filler {
						display: block;
						flex: 1 1 100%;
						cursor: auto;
						height: auto;
						border-right-width: 0;
					}

					&:hover,
					&.active {
						color: $c-slate-dark;
						border-color: $c-grey;
					}

					&.active {
						border-bottom-color: transparent;
						background-color: $c-white;
					}
				}
			}
		}

		.tab-panel-body {
			@include flex(1);
			padding: $size-small;
		}

		&.no-tabs {
			border-width: 1px;
		}
	}
</style>
<template>
	<div
		class="tab-panel"
		:class="{
			'no-tabs': tabs.length < 2
		}">
		<tab-container
			class="tab-panel-tabs"
			v-if="tabs.length > 1"
			:model-key="tabKey">
			<button
				v-for="tab in tabs"
				:key="tab.id"
				:data-tab="tab.id"
				:disabled="tab.disabled"
				v-tooltip="tab.disabled && tab.disabledTooltip"
				class="tab-panel-tab tooltip-bottom"
				@click="onTabClick"
				:class="{
					active: activeTab === tab.id
				}">
				{{ tab.text }}
			</button>
			<div class="tab-panel-tab tab-filler"></div>
		</tab-container>
		<div
			class="tab-panel-body"
			ref="tabPanelBody"
			v-scroll-target-helper-local
			@scroll="onBodyScroll"
			:data-panel="activeTab">
			<slot name="tab-panel-body"></slot>
		</div>
		<!-- refactor to use snap-to-top component -->
		<button
			class="button snap-to-top"
			:class="{
				'snap-to-top-visible': snapToTopVisible
			}"
			@click.prevent="scrollToTop">
			&#x25B2;
		</button>
	</div>
</template>
